import { render, staticRenderFns } from "./headerLink.vue?vue&type=template&id=dae7e9bc&scoped=true"
import script from "./headerLink.vue?vue&type=script&lang=ts"
export * from "./headerLink.vue?vue&type=script&lang=ts"
import style0 from "./headerLink.vue?vue&type=style&index=0&id=dae7e9bc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dae7e9bc",
  null
  
)

export default component.exports